<script>
	export default {
		name: 'GroupExecuter',
		methods: {
			setUserGroup(code, name, description) {
				const self_ = this;

				const group_ = {
					name: name,
					description: description
				}
				return self_.setFirestoreDocument('groups', code, group_)
			},
			deleteUserGroup(code) {
				const self_ = this;
				return self_.deleteFirestoreDocument('groups', code)
			},
			checkSecurityGroup(target, def) {
				const self_ = this;

				let securityGroup_ = self_.getUserState('securityGroupCode')
				if(self_.isFalse(securityGroup_)) { securityGroup_ = 'nonUser' }

				return self_.$_grpExec_checkGroup(securityGroup_, target, def)
			},
			checkMenuGroup(target, def) {
				const self_ = this;

				const menuGroup_ = self_.getAppState('menuGroup')

				return self_.$_grpExec_checkGroup(menuGroup_, target, def)
			},
			$_grpExec_checkGroup(group, target, def) {
				const self_ = this;

				const check_ = name => {
					if(self_.isObject(group)) {
						return group[name] == true
					} else {
						return group == name
					}
				}
				
				let result_ = false;

				if(self_.isFalse(target)) { return result_ || def }

				if(self_.isObject(target)) {
					Object.keys(target).forEach(key => {
						if(target[key]) {
							result_ = result_ || key == 'all' || check_(key)
						}
					})
				} else { result_ = check_(target) }

				return result_
			}
		}
	}
</script>
